import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useSensorStreamController } from '../sensors/sensors-stream';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { useTranslation } from 'react-i18next';

export default function StreamButton() {
    const { start, stop, activated } = useSensorStreamController();
    const { t } = useTranslation();
    
    if (activated) {
        return (
            <Button variant="outlined" startIcon={<PauseIcon />} onClick={stop}>
                {t('DEVICES.DETAILS.TASKS_CARD.STOP_STREAM')}
            </Button>
        )
    } else {
        return (
            <Button variant="outlined" startIcon={<PlayArrowIcon />} onClick={start}>
                {t('DEVICES.DETAILS.TASKS_CARD.START_STREAM')}
            </Button>
        )
    }
}

StreamButton.propTypes = {

}
